import { getApp, getApps, initializeApp, type FirebaseApp } from 'firebase/app';
import {
  getToken,
  initializeAppCheck,
  ReCaptchaV3Provider,
  type AppCheck,
} from 'firebase/app-check';

/**
 * The site's one Firebase app, shared by the demo form (App Check) and the free-trial form (phone
 * OTP). `initializeApp` throws when called twice in one page, and a visitor can open both forms
 * without a reload, so neither creates its own. Null when the build has no Firebase config
 * (local, previews).
 */
export function firebaseApp(): FirebaseApp | null {
  const apiKey = import.meta.env.VITE_FIREBASE_API_KEY;
  const appId = import.meta.env.VITE_FIREBASE_APP_ID;
  if (!apiKey || !appId) return null;
  if (getApps().length) return getApp();
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID || 'transport-manager-dee0c';
  return initializeApp({ apiKey, appId, projectId, authDomain: `${projectId}.firebaseapp.com` });
}

let appCheck: AppCheck | null = null;

/** An App Check token for the demo function, or '' when the build has no reCAPTCHA key. */
export async function appCheckToken(): Promise<string> {
  const app = firebaseApp();
  const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
  if (!app || !siteKey) return '';
  appCheck ??= initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(siteKey),
    isTokenAutoRefreshEnabled: true,
  });
  return (await getToken(appCheck)).token;
}
